import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const MarketingSection = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="services" className="bg-[#0d6571] py-20" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className={`text-white space-y-6 transition-all duration-1000 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-20 opacity-0'}`}>
            <h2 className="text-4xl md:text-5xl font-bold">Marketing</h2>
            <p className="text-lg leading-relaxed">
              Marketing is the process of creating, communicating, and delivering value
              to customers for the purpose of promoting products, services, or ideas. It
              involves various strategies, tactics, and activities aimed at understanding
              customer needs and preferences, developing products or services that fulfill
              those needs, and effectively reaching and persuading target audiences to
              choose and engage with those offerings.
            </p>
            <p className="text-lg leading-relaxed">
              Marketing encompasses a wide range of activities that revolve around
              building and maintaining customer relationships, ultimately driving sales
              and achieving business goals.
            </p>
            <Button
              variant="outline"
              onClick={() => navigate('/marketing')}
              className="border-2 border-white text-white rounded-full px-8 py-6 text-lg hover:bg-white hover:text-[#0d6571] transition-all duration-300 group mt-4"
            >
              Learn more
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {/* Image with floating animation */}
          <div className={`relative transition-all duration-1000 delay-300 ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-20 opacity-0'}`}>
            <div className="rounded-2xl overflow-hidden shadow-2xl group">
              <div className="relative overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80"
                  alt="Marketing Team"
                  className="w-full h-auto object-cover transform group-hover:scale-110 transition-transform duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d6571]/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketingSection;
